import {
	DateLanguage,
	Language
} from '@common/enums/global.enums'
import { Tab } from '@common/types/global.types'
import { Route } from '@config/routes/routes.enums'
import {
	deDE,
	enUS as enUSLocaleText,
	esES,
	frFR,
	itIT
} from '@mui/x-date-pickers/locales'
import {
	de,
	enUS,
	es,
	fr,
	it
} from 'date-fns/locale'

// Languages
export const DATE_LANGUAGE = {
	[DateLanguage.FR]: fr,
	[DateLanguage.US]: enUS,
	[DateLanguage.ES]: es,
	[DateLanguage.DE]: de,
	[DateLanguage.IT]: it
}

export const DATE_LOCALE_TEXT = {
	[DateLanguage.FR]: frFR,
	[DateLanguage.US]: enUSLocaleText,
	[DateLanguage.ES]: esES,
	[DateLanguage.DE]: deDE,
	[DateLanguage.IT]: itIT
}

export const DATE_FORMAT = 'dd/MM/yyyy'

export const LANGUAGE = {
	[Language.DE]: 'DE',
	[Language.EN]: 'EN',
	[Language.ES]: 'ES',
	[Language.FR]: 'FR',
	[Language.IT]: 'IT'
}

// Tabs
export const TABS: Tab[] = [
	{ route: Route.TRAINEES },
	{ route: Route.ANALYTICS, isAdmin: true }
]

// Utils
export const DEBOUNCE_WAIT_TIME = 500

export const REGEX = {
	EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
}
